module.exports = __webpack_public_path__ + "static/media/cn.de59a1c6.svg";